module.exports = __webpack_public_path__ + "static/media/agency-alpha.6e149aa9.png";